"use client";
import { hasArrayElements } from "@/apiUtils/commonUtils";
import { HeroBannerFeaturedProductData } from "@/common/lib/types";
import { CLink } from "@/components/common/customLink/CustomLink";
import { cn } from "@/lib/tailwind";
import { getCloudinaryURL } from "@/utils/cloudinary";
// import Image from "next/image";
import { useState } from "react";
import NoImageSrc from "@/assets/images/no_image.svg";
import CldImage from "@/components/ui/cldImg/CldImage";
import { useMediaQuery } from "@/hooks/useMediaQuery";

interface FeaturedProductsProps {
  content: HeroBannerFeaturedProductData;
}

const FeaturedProducts = ({ content }: FeaturedProductsProps) => {
  const [active, setActive] = useState(0);
  const items = content?.items?.slice(0, Math.min(2, content.items.length));

  const isSmallScreen = useMediaQuery("(max-width: 640px)", {
    defaultValue: false,
    initializeWithValue: true,
  });

  return (
    <div className="">
      <div className="relative flex h-[4.5rem] w-full items-center bg-primary-2 md:bg-transparent md:text-white">
        {content?.items &&
          hasArrayElements(content?.items) &&
          items?.map((product, idx) => {
            return <div
              key={idx}
              className={cn(
                "absolute flex justify-start transition-[left,right,opacity]",
                active === idx
                  ? "left-12 z-20 opacity-100 md:left-14"
                  : "left-5 z-10 opacity-70 md:left-0 md:right-14 md:bg-transparent",
              )}
            >
              <div
                className={cn(
                  "flex h-[3rem] w-[3rem] items-center border border-black bg-white p-2 md:h-[4.1rem] md:w-[4.1rem]",
                )}
                onClick={() => setActive(idx)}
              >
                <CldImage
                  src={product.thumbnail ? getCloudinaryURL(product.thumbnail) : NoImageSrc}
                  alt={product.name}
                  width={80}
                  height={80}
                  className="h-auto w-full object-cover"
                />
              </div>
              <div
                className={cn("flex items-center", active === idx ? "opacity-100" : "opacity-0")}
              >
                <CLink
                  href={product.link?.url ?? ""}
                  className={cn(
                    "px-5 text-sm md:rounded-r-full md:py-2 md:pr-9 md:bg-[rgba(0,0,0,0.5)] md:text-white",
                  )}
                  style={
                    !isSmallScreen ? {
                      color: content?.color,
                      backgroundColor: content?.backgroundColor
                    } : undefined
                  }
                >
                  <h3 className="font-bold">{product.title}</h3>
                  <p className="text-size-10 underline md:text-sm">{product.subTitle}</p>
                </CLink>
              </div>
            </div>
          })}
      </div>
    </div>
  );
};

export default FeaturedProducts;
